const configs = {
  VITE_ENV: import.meta.env.VITE_ENV,
  VITE_API_SERVER: import.meta.env.VITE_API_SERVER,
};

const appConfig = (key: keyof typeof configs) => {
  return configs[key] ?? '';
};

export default appConfig;
